import React from "react";

// Pantalla de "sin datos" reutilizable. Se mantiene el header de cada pantalla
// y esto ocupa el área de contenido con un texto centrado "No hay {label} aún".
// `label` es el sustantivo de la colección (ej. "ventas", "clientes", "stock").
const EmptyState = ({ label }) => (
  <div className="empty-state">
    <p>No hay {label} aún</p>
  </div>
);

export default EmptyState;
